import React from 'react'
import LadingNaveBar from '../../components/Landing-page-components/ladingNaveBar/LadingNaveBar';
import { Outlet } from 'react-router-dom';

const LandingPageLayOut = () => {
  return (
    <div className="LandingPage">
      <LadingNaveBar />
      <div className="LandingPage-body">
        <Outlet/>
      </div>
    </div>
  );
}

export default LandingPageLayOut